export * from './createTableEndpointFromOas';
